export default class PositionGroups {
  static goalkeeper = "GK";
  static fullBack = "DL/DR";
  static centralDefence = "DC";
  static wingBack = "WBL/WBR";
  static defensiveMidfield = "DMC";
  static wideMidfield = "ML/MR";
  static centralMidfield = "MC";
  static wingForward = "AML/AMR";
  static attackingMidfield = "AMC";
  static centralAttack = "STC"; 
}
